// extracted by mini-css-extract-plugin
module.exports = {"Error":"error_Error__4ydum","title":"error_title__EM9F_","txt":"error_txt__niIps","confirm":"error_confirm__gUjxW"};